// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import {
    setActiveTab,
    setPage,
} from '../../storage/actions/applicationStateActions';

const PaginationPage = ({ applicationState, workOrderCountByTabs, setPage }) => {
    const totalWorkOrders = workOrderCountByTabs[applicationState.activeTab] || 0;
    const perPage = 20;
    const countOfPages = Math.max(Math.ceil(totalWorkOrders / perPage), 1);

    const isDisabled = totalWorkOrders === 0 || countOfPages <= 1;

    if (isDisabled) {
        return null;
    }

    const PageComponent = ({ number }) => (
        <li>
            <a
                href="#"
                className={`${number === applicationState.currentPage ? 'current_page' : ''}`}
                onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo(0, 0);
                    setPage(number);
                }}
            >
                {number || '...'}
            </a>
        </li>
    );

    const renderPages = (total, currentPage) => {
        if (total <= 5) {
            return Array.from({ length: total }).map((_, i) => (
                <PageComponent key={i + 1} number={i + 1} />
            ));
        }

        if (currentPage <= 3) {
            return (
                <>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <PageComponent key={i + 1} number={i + 1} />
                    ))}
                    <PageComponent />
                    <PageComponent number={total} />
                </>
            );
        }

        if (currentPage >= total - 2) {
            return (
                <>
                    <PageComponent number={1} />
                    <PageComponent />
                    {Array.from({ length: 3 }).map((_, i) => (
                        <PageComponent key={total - 2 + i} number={total - 2 + i} />
                    ))}
                </>
            );
        }

        return (
            <>
                <PageComponent number={1} />
                <PageComponent />
                <PageComponent number={currentPage - 1} />
                <PageComponent number={currentPage} />
                <PageComponent number={currentPage + 1} />
                <PageComponent />
                <PageComponent number={total} />
            </>
        );
    };

    return (
        <div className="paging dashboard-pagination-inner">
            <ul>
                <li>
                    <a
                        href="#"
                        className={`prev_page icon_prev ${
                            applicationState.currentPage === 1 ? 'inactive' : ''
                        }`}
                        onClick={(e) => {
                            e.preventDefault();
                            if (applicationState.currentPage === 1) return;
                            window.scrollTo(0, 0);
                            setPage(applicationState.currentPage - 1);
                        }}
                    >
                        Prev
                    </a>
                </li>

                {renderPages(countOfPages, applicationState.currentPage)}

                <li>
                    <a
                        href="#"
                        className={`next_page icon_next ${
                            applicationState.currentPage === countOfPages ? 'inactive' : ''
                        }`}
                        onClick={(e) => {
                            e.preventDefault();
                            if (applicationState.currentPage === countOfPages) return;
                            window.scrollTo(0, 0);
                            setPage(applicationState.currentPage + 1);
                        }}
                    >
                        Next
                    </a>
                </li>
            </ul>
        </div>
    );
};

const mapDispatchToProps = {
    setActiveTab,
    setPage,
};

const mapStateToProps = (state) => ({
    applicationState: state.applicationState,
});

export default connect(mapStateToProps, mapDispatchToProps)(PaginationPage);
